import { Component, OnInit } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import {FormsModule} from '@angular/forms';

import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { HotRegisterer } from 'angular-handsontable';
import { ToastrService } from 'ngx-toastr';

import {Report} from '../shared/report.model';
import {ReportDataService} from '../report-data.service';

@Component({
  selector: 'app-allocation-modal',
  templateUrl: './allocation-modal.component.html',
  styleUrls: ['./allocation-modal.component.scss']
})
export class AllocationModalComponent implements OnInit {

  private description = '';
  private state = 'CREATE';
  private model = { name: '', allocationType: 'Manual' };
  private report: Report;
  private sourceData;
  private methodData;
  private componentData;
  private methodTableData = new Array<MethodTableLineItem>();
  private methodSequence = 1;
  private componentAllocationMethodCol = '';
  private componentIDCol = '';
  private costDefAllocationCol = '';
  private costDefIDCol = '';
  private costHourDefTable = [];
  private dropdownDisplayField = 'Name';
  private allocationDollarMap;

  constructor(private toastr: ToastrService, public bsModalRef: BsModalRef, private reportService: ReportDataService) {
  }

  ngOnInit() {
    this.report = this.reportService.getReport();
    if (this.reportService.currentError.type === 'WBS_ALLOCATION') {
      this.description = 'WBS';
      this.sourceData = this.report.WBS.data;
      this.allocationDollarMap = this.report.WBSAllocationDollarMap;
      this.methodData = this.report.WBSAllocationMethods;
      this.componentData = this.report.WBSAllocationComponents;
      this.componentAllocationMethodCol = 'WBSAllocationMethodID';
      this.componentIDCol = 'WBSElementID';
      this.costDefAllocationCol = 'WBSAllocationMethodID';
      this.costDefIDCol = 'WBSElementID';
      this.dropdownDisplayField = 'ID';
    }
    if (this.reportService.currentError.type === 'ORDER_OR_LOT_ALLOCATION') {
      this.description = 'Orders or Lots';
      this.sourceData = this.report.OrdersOrLots.data;
      this.allocationDollarMap = this.report.OrderOrLotAllocationDollarMap;
      this.methodData = this.report.OrderOrLotAllocationMethods;
      this.componentData = this.report.OrderOrLotAllocationComponents;
      this.componentAllocationMethodCol = 'OrderOrLotAllocationMethodID';
      this.componentIDCol = 'OrderOrLotID';
      this.costDefAllocationCol = 'OrderOrLotAllocationMethodID';
      this.costDefIDCol = 'OrderOrLotID';
    }
    if (this.reportService.currentError.type === 'UNIT_OR_SUBUNIT_ALLOCATION') {
      this.description = 'Units or Sublots';
      this.sourceData = this.report.UnitsOrSublots.data;
      this.allocationDollarMap = this.report.UnitOrSublotAllocationDollarMap;
      this.methodData = this.report.UnitOrSublotAllocationMethods;
      this.componentData = this.report.UnitOrSublotAllocationComponents;
      this.componentAllocationMethodCol = 'UnitOrSublotAllocationMethodID';
      this.componentIDCol = 'UnitOrSublotID';
      this.costDefAllocationCol = 'UnitOrSublotAllocationMethodID';
      this.costDefIDCol = 'UnitOrSublotID';
      this.dropdownDisplayField = 'ID';
    }
    if (this.reportService.currentError.type === 'END_ITEM_ALLOCATION') {
      this.description = 'End Items';
      this.sourceData = this.report.EndItems.data;
      this.allocationDollarMap = this.report.EndItemAllocationDollarMap;
      this.methodData = this.report.EndItemAllocationMethods;
      this.componentData = this.report.EndItemAllocationComponents;
      this.componentAllocationMethodCol = 'EndItemAllocationMethodID';
      this.componentIDCol = 'EndItemID';
      this.costDefAllocationCol = 'EndItemAllocationMethodID';
      this.costDefIDCol = 'EndItemID';
    }
    this.getCostDefsNeedingAllocation();
    //add a few empty lines to get started
    this.methodTableData.push(new MethodTableLineItem());
    this.methodTableData.push(new MethodTableLineItem());
  }

  getCostDefsNeedingAllocation() {
    //look for rows in cost hour def where costDefCol is null or empty
    for (let i = 0; i < this.report.CostHourDefinitions.data.length; i++) {
      let currentItem = this.report.CostHourDefinitions.data[i];
      if ( currentItem[this.costDefIDCol] == null || ('' + currentItem[this.costDefIDCol]).trim().length === 0) {
        this.costHourDefTable.push(currentItem);
      }
    }
  }

  handleAllocation() {
    if (this.model.allocationType !== 'Pro-Rated') {
      return;
    }

    let total = 0;
    for (let i=0; i < this.methodTableData.length; i++) {
      if(this.methodTableData[i].Id == null) {
          continue;
      }
      if(this.allocationDollarMap[this.methodTableData[i].Id] == null || this.allocationDollarMap[this.methodTableData[i].Id] === 0) {
        this.allocationDollarMap[this.methodTableData[i].Id] = 0;
        this.toastr.warning('The item you chose to pro-rate allocations based off of has $0 allocated to it.  Will default to 0% in allocation.', 'Zero Dollar Allocation');
      }
      total += this.allocationDollarMap[this.methodTableData[i].Id];
    }

    for (let i=0; i < this.methodTableData.length; i++) {
      if(this.methodTableData[i].Id == null) {
          continue;
      }
      if(total === 0) {
        this.methodTableData[i].percent = 0;
      } else {
        this.methodTableData[i].percent = Math.round(this.allocationDollarMap[this.methodTableData[i].Id] / total * 100);
      }
    }

  }

  addRow() {
    this.methodTableData.push(new MethodTableLineItem());
  }

  addMethod() {
    if (!this.isAllocationValid()) {
      return;
    }
    this.storeData();
    this.emptyDisplay();
  }

  emptyDisplay() {
    this.model.name = '';
    this.methodTableData.length = 0;
    this.methodTableData.push(new MethodTableLineItem());
    this.methodTableData.push(new MethodTableLineItem());
  }

  next() {
    if (!this.isAllocationValid()) {
      return;
    }
    this.storeData();
    this.state = 'MAP';
  }

  done() {
    if (!this.isAllocationMapValid()) {
      return;
    }
    //let report service potentially clear out errors
    if (!this.report.CostHourDefinitions.requiresAllocation(this.costDefIDCol, this.costDefAllocationCol, this.costDefIDCol)) {
      this.reportService.popError(this.reportService.currentError.type);
    }
    this.bsModalRef.hide();
  }

  storeData() {
    const id = this.getNextId();

    //store ID and name of our method
    this.methodData.data.push({ID: id, Name: this.model.name});

    //store component definition
    for (let i = 0; i < this.methodTableData.length; i++) {
      const currentItem = this.methodTableData[i];
      this.componentData.data.push({
        [this.componentAllocationMethodCol]: id,
        [this.componentIDCol]: currentItem.Id,
        'PercentValue': currentItem.percent,
      });
    }
  }

  isAllocationValid() {
    let isValid = true;

    let total = 0;
    if (this.model.name == null || this.model.name.trim().length === 0) {
        isValid = false;
        this.toastr.error('Allocation Method has to have a name', 'Name Me!');
    }
    for (let i = 0; i < this.methodTableData.length; i++) {
      total += this.methodTableData[i].percent;
    }
    if (total !== 100 && this.model.allocationType === 'Manual') {
        isValid = false;
        this.toastr.error('Allocation Method percentages need to add up to 100', 'Fix Some Math');
    }
    if (this.methodTableData.length <= 1) {
        isValid = false;
        this.toastr.error('Allocations must be across at least 2 categories', 'Need More Allocations');
    }
    return isValid;
  }

  isAllocationMapValid() {
    let isValid = true;
    for (let i = 0; i < this.costHourDefTable.length; i++) {
      if ((this.costHourDefTable[i][this.costDefAllocationCol] == null) || (this.costHourDefTable[i][this.costDefAllocationCol].trim().length === 0)) {
          isValid = false;
      }
    }
    if (!isValid) {
      this.toastr.error('Sorry...we need you to map all the allocations before continuing', 'Keep on Mappin\'');
    }
    return isValid;
  }

  removeRow(index) {
    this.methodTableData.splice(index, 1);
    this.handleAllocation();
  }

  getNextId() {
    let maxId = 0;
    for (let i = 0; i < this.methodData.data.length; i++) {
      if (this.methodData.data[i].ID > maxId) {
        maxId = this.methodData.data[i].ID;
      }
    }
    return (maxId + 1);
  }
}

export class MethodTableLineItem {
  Id: string;
  percent = 0;

  constructor() {

  }
}



// WEBPACK FOOTER //
// ./src/app/allocation-modal/allocation-modal.component.ts